import React, { FC } from 'react';
import './Navbar-Admin.css';
import {Link} from 'react-router-dom';
import { SignOutLink } from '../core/SignOutLink/SignOutLink';

interface NavbarAdminProps {}
const username = sessionStorage.getItem('userName');
const NavbarAdmin: FC<NavbarAdminProps> = () => (
    <div className="PrimaryNavigation">
    <nav className="pds-navigationPrimary pds-navigationPrimary-white">
  <div className="pds-navigationPrimary-container container">
    <div className="pds-navigationPrimary-logo">
      <a data-gtm="navigation-primary" className="pds-navigationPrimary-logo-link pds-link-unstyled" href="#" aria-label="Principal Homepage">
        <img alt="" className="pds-imgLogoGradientRight"/>
      </a>
    </div>
    <div className="pds-navigationPrimary-menu-container">
      <ul className="pds-navigationPrimary-tier-one">
        <li>
          <a data-gtm="navigation-primary" href="" aria-haspopup="true">
          <Link to="/">Inicio</Link>
          </a>
        </li>
        <li>
          <a data-gtm="navigation-primary" className="pds-link-unstyled pds-navigationPrimary-dropdown-link" href="" aria-haspopup="true">
            Menu Repositorios
          </a>
          <ul className="pds-navigationPrimary-tier-two">
            <li>
              <a data-gtm="navigation-primary" href="#" className="pds-link-unstyled"><Link to="/repositories">Repositorios</Link></a>
            </li>
            <li>
              <a data-gtm="navigation-primary" href="#" className="pds-link-unstyled"><Link to="/my-repositories">Mis Repositorios</Link></a>
            </li>
            <li>
              <a data-gtm="navigation-primary" href="#" className="pds-link-unstyled"><Link to="/new-repository">Nuevo Repositorio</Link></a>
            </li>
          </ul>
        </li>
        {/* <li>
          <a data-gtm="navigation-primary" className="pds-link-unstyled pds-navigationPrimary-dropdown-link" href="" aria-haspopup="true">
            Administracion de repositorios
          </a>
          <ul className="pds-navigationPrimary-tier-two">
            <li>
              <a data-gtm="navigation-primary"className="pds-link-unstyled"><Link to="/RepositoryContent">Repositorios</Link></a>
            </li>
            <li>
              <a data-gtm="navigation-primary" href="#" className="pds-link-unstyled">Repositorios eliminados</a>
            </li>
            <li>
              <a data-gtm="navigation-primary" href="#" className="pds-link-unstyled">Logs de auditoria</a>
            </li>
          </ul>
        </li> */}
      </ul>
    </div>
    <div className="pds-navigationPrimary-actions-container pds-navigationPrimary-tier-one-menu-item">
      <div className="pds-navigationPrimary-search-wrapper">
        <button data-gtm="call-to-action" className="pds-navigationPrimary-search-icon-link pds-util-focus-visible-only" aria-expanded="false" aria-label="search" type="button">
          <span className="sr-only pds-navigationPrimary-hide-mobile-elements">Search</span>
        </button>
        <div className="pds-navigationPrimary-search-dropdown pds-navigationPrimary-menu-container">
          <div className="pds-avatar">
            <div className="pds-avatar-media">
              <i className="pds-avatar-icon" data-feather="user" aria-hidden="true" data-size={20} />
            </div>
            <div className="pds-avatar-info" style={{ justifyContent: 'space-between' }}>
              <div className="pds-avatar-name">
                <a href="#" className="pds-link-emphasis">
               {username}
                </a>
              </div>
              <div className="pds-avatar-details" style={{ display: 'inline-block' }}>
                <SignOutLink/>
                </div>
            </div>
          </div>
          <div className="pds-navigationPrimary-close-search-wrapper">
            <button data-gtm="call-to-action" className="pds-link pds-link-unstyled pds-navigationPrimary-close-search" type="button">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
  </div>
);

export default NavbarAdmin;